import { memoize } from "lodash";
import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingLibraryImprovements = function () {
    return utilBalancing.getBalancing().LibraryImprovements;
};
export var selectLibraryResearchItemBalancingInfo = memoize(function (id) { return selectBalancingLibraryImprovements().get(id); });
export var balancingLibraryImprovementsMemoizedFunctions = [
    selectBalancingLibraryImprovements,
    selectLibraryResearchItemBalancingInfo,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingLibraryImprovements.ts
// module id = 676
// module chunks = 3